module.exports = __webpack_public_path__ + "static/media/mastercard.776e7a70.svg";